var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { LookupNames } from "../../../../../../core/constants/lookup";
import { TrackedItemsVariables, TrackedItemTypebenchmark, } from "../../../../../../core/constants/TrackedItemsConstants";
import { trackedItemTypesListingRoute } from "../../../../../../core/constants/routesPath";
import { notifications } from "../../../../../../layout/components/notifications";
import { getLookup, getLookups } from "../../../../../../redux/lookup/actions";
import { getTrackedItemTypes, getSystemCreatedTrackedItemTypes, editTrackedItemType, getHiddenTrackedItemTypes, addTrackedItemType, } from "../../../../../../redux/tracked-item-type/actions";
import TrackedItemTypeForm from "./components/trackedItemTypeForm";
import localize from "../../../../../../core/utils/translation-files";
import { getTrackedItems } from "../../../../../../redux/trackedItem/actions";
import { getLookupByListing } from "../../../../../../core/helpers/lookupHanlder";
import { initialTrackedItemType } from "../../defaultValues";
import "../trackedItemType.scss";
import "../../../../../../layout/components/numericInput/numericInput.scss";
import "../../../../../../layout/components/numericColoredRanges/numericColoredRanges.scss";
import { getRatingValues } from "../../../../../../layout/components/numericColoredRanges/utils";
import { SessionStorage } from "../../../../../../core/helpers/localStorage/sessionStorage";
import { SessionVariables } from "../../../../../../core/constants/SessionVariables";
import { TrackedItemTypeApi } from "../../../../../../core/api/trackedItemTypeApi";
import isEmpty from "../../../../../../core/helpers/isEmpty";
const TrackedItemTypeFormContainer = ({ trackedItemTypes, getTrackedItemTypes, getSystemCreatedTrackedItemTypes, getHiddenTrackedItemTypes, addTrackedItemType, editTrackedItemType, benchmarkListOptions, getLookup, getTrackedItems, getLookups, }) => {
    var _a, _b;
    const isSystemCreated = SessionStorage.getKey(SessionVariables.DEFAULTS_ACTIVE_TAB) ===
        TrackedItemsVariables.SYSTEM_TRACKED_ITEM;
    const isHidden = SessionStorage.getKey(SessionVariables.DEFAULTS_ACTIVE_TAB) ===
        TrackedItemsVariables.HIDDEN_TRACKED_ITEM;
    const [trackedItemType, setTrackedItemType] = useState(Object.assign(Object.assign({}, initialTrackedItemType), { itemSubCategoryId: isSystemCreated ? -1 : undefined, itemTopicId: isSystemCreated ? -1 : undefined, systemCreated: isSystemCreated, isHidden: isHidden }));
    const [categoryOptions, setCategoryOptions] = useState();
    const [bandScales, setBandScales] = useState(undefined);
    const params = useParams();
    const [key, setKey] = useState(0);
    const history = useHistory();
    const location = useLocation();
    const categoryValues = useSelector((state) => state.lookups[LookupNames.LKItemCategory]);
    useEffect(() => {
        var _a, _b, _c, _d;
        getLookupByListing({
            LookupNames: [
                LookupNames.LKReportType,
                LookupNames.LKReportValueType,
                LookupNames.LKReportTypeDataFrequency,
                LookupNames.LKReportTypeProjectionAverage,
                LookupNames.LKReportTypeBenchmarkDirection,
                LookupNames.LKReportTypeBenchmark,
                LookupNames.LKItemCategory,
                LookupNames.LKItemSubCategory,
                LookupNames.LKItemRiskLevel,
                LookupNames.LKChartDisplayUnit,
                LookupNames.LKReportWeight,
                LookupNames.LKDisplayValue,
                LookupNames.LKReportsTypeFilter,
                LookupNames.LKIntegrationSystem
            ],
            getLookups,
        });
        !isSystemCreated &&
            TrackedItemTypeApi.getCategoryDefaults().then((res) => setCategoryOptions(res));
        if (trackedItemTypes.length === 0) {
            isSystemCreated
                ? getSystemCreatedTrackedItemTypes().catch((error) => {
                    throw error;
                })
                : isHidden
                    ? getHiddenTrackedItemTypes().catch((error) => {
                        throw error;
                    })
                    : getTrackedItemTypes().catch((error) => {
                        throw error;
                    });
        }
        if (params.id && params.id > 0 && ((_a = location.state) === null || _a === void 0 ? void 0 : _a.reportTypeId)) {
            const trackedItemType = trackedItemTypes === null || trackedItemTypes === void 0 ? void 0 : trackedItemTypes.filter((x) => x.id === parseInt(params.id))[0];
            if (trackedItemType) {
                const newValues = JSON.parse(JSON.stringify(trackedItemType));
                // Handle hashTags transformation to tagIds format
                if (trackedItemType.hashTags &&
                    Array.isArray(trackedItemType.hashTags)) {
                    newValues.tagIds = trackedItemType.hashTags.map((tag) => {
                        var _a;
                        return ({
                            tagId: tag.id,
                            name: tag.name,
                            nameLower: ((_a = tag.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "",
                            parentId: tag.parentId !== undefined ? tag.parentId : null,
                            path: Array.isArray(tag.path) ? tag.path : null,
                            active: tag.active !== undefined ? tag.active : true,
                        });
                    });
                    delete newValues.hashTags;
                }
                else if (trackedItemType.tags) {
                    newValues.tagIds = trackedItemType.tags;
                    delete newValues.tags;
                }
                const ratingScale = Object.entries(trackedItemType)
                    .map(([key, value]) => {
                    if (key.includes("ratingScale")) {
                        return {
                            bandName: key[key.length - 1],
                            title: value,
                        };
                    }
                    else {
                        return null;
                    }
                })
                    .filter((value) => !isEmpty(value));
                setBandScales(ratingScale);
                if ((_b = trackedItemType.benchmarkList) === null || _b === void 0 ? void 0 : _b.length) {
                    newValues.benchmarkList = (_c = newValues.benchmarkList) === null || _c === void 0 ? void 0 : _c.map((benchmark) => {
                        return Object.assign(Object.assign({}, benchmark), {
                            gradeRanges: getRatingValues(newValues.requiredBenchmarkDirection, benchmark),
                        });
                    });
                }
                const { associatedTrackedItems } = newValues, rest = __rest(newValues, ["associatedTrackedItems"]);
                let sortedAssociatedTrackedItems = associatedTrackedItems === null || associatedTrackedItems === void 0 ? void 0 : associatedTrackedItems.sort((a, b) => (a === null || a === void 0 ? void 0 : a.priority) - (b === null || b === void 0 ? void 0 : b.priority));
                setTrackedItemType(Object.assign(Object.assign({}, rest), { sysIntegrationIds: (_d = rest === null || rest === void 0 ? void 0 : rest.sysIntegrationIds) === null || _d === void 0 ? void 0 : _d.split(","), associatedTrackedItems: sortedAssociatedTrackedItems }));
                setKey(Math.random());
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // benchmarkListOptions.length,
        getTrackedItemTypes,
        getSystemCreatedTrackedItemTypes,
        getHiddenTrackedItemTypes,
        params.id,
        trackedItemTypes,
    ]);
    const saveTrackedItemTypeHandler = (trackedItemType, setErrors, resetForm) => {
        var _a, _b, _c;
        const payloadAssociations = [...trackedItemType === null || trackedItemType === void 0 ? void 0 : trackedItemType.associatedTrackedItems];
        const formatedAssociations = (_b = (_a = payloadAssociations === null || payloadAssociations === void 0 ? void 0 : payloadAssociations.filter((item) => item.name)) === null || _a === void 0 ? void 0 : _a.map((value, index) => {
            return Object.assign(Object.assign({}, value), { priority: index + 1 });
        })) === null || _b === void 0 ? void 0 : _b.sort((a, b) => (a === null || a === void 0 ? void 0 : a.id) - (b === null || b === void 0 ? void 0 : b.id));
        let updatedAssocition = formatedAssociations.filter((value) => value === null || value === void 0 ? void 0 : value.id);
        const newAssociatedItem = formatedAssociations.filter((value) => !(value === null || value === void 0 ? void 0 : value.id));
        if (newAssociatedItem === null || newAssociatedItem === void 0 ? void 0 : newAssociatedItem.length) {
            updatedAssocition = [...updatedAssocition, ...newAssociatedItem];
        }
        trackedItemType.associatedTrackedItems = updatedAssocition;
        if (!isSystemCreated && !isHidden) {
            trackedItemType.sysIntegrationIds = (_c = trackedItemType === null || trackedItemType === void 0 ? void 0 : trackedItemType.sysIntegrationIds) === null || _c === void 0 ? void 0 : _c.join(",");
        }
        if (trackedItemType.id > 0) {
            editTrackedItemType(trackedItemType).then((response) => {
                if (!response || !response.code) {
                    resetForm();
                    notifications.success(localize(["TrackedItem.default", "updated", "successfully"]));
                    history.push(trackedItemTypesListingRoute);
                }
            });
            return;
        }
        addTrackedItemType(trackedItemType).then((response) => {
            if (!response || !response.code) {
                resetForm();
                notifications.success(localize(["TrackedItem.default", "created", "successfully"]));
                history.push(trackedItemTypesListingRoute);
            }
        });
    };
    if ((params === null || params === void 0 ? void 0 : params.id) && !((_a = location.state) === null || _a === void 0 ? void 0 : _a.reportTypeId)) {
        history.push(trackedItemTypesListingRoute);
    }
    return (React.createElement(TrackedItemTypeForm, { intialTrackedItemType: trackedItemType, key: key, onSubmit: saveTrackedItemTypeHandler, trackedItemTypes: trackedItemTypes, benchmarkListOptions: benchmarkListOptions, isSystemCreated: isSystemCreated, isSystemCreatedEdit: (_b = history.location.state) === null || _b === void 0 ? void 0 : _b.systemCreated, categoryOptions: categoryOptions, categories: categoryValues, bandScales: bandScales, setBandScales: setBandScales, isHidden: isHidden }));
};
function mapStateTopProps(state, ownProps) {
    var _a, _b;
    const trackedItemReducer = state.trackedItemTypes;
    const isSystemCreated = SessionStorage.getKey(SessionVariables.DEFAULTS_ACTIVE_TAB) ===
        TrackedItemsVariables.SYSTEM_TRACKED_ITEM;
    const isHidden = SessionStorage.getKey(SessionVariables.DEFAULTS_ACTIVE_TAB) ===
        TrackedItemsVariables.HIDDEN_TRACKED_ITEM;
    return {
        // trackedItemTypes: ownProps?.location.state?.systemCreated
        //   ? trackedItemReducer?.systemCreatedTrackedItems
        //   : ownProps?.location.state?.isHidden ?  trackedItemReducer?.getHiddenTrackedItemTypes : trackedItemReducer?.userCreatedTrackedItem,
        trackedItemTypes: isSystemCreated
            ? trackedItemReducer === null || trackedItemReducer === void 0 ? void 0 : trackedItemReducer.systemCreatedTrackedItems
            : isHidden
                ? trackedItemReducer === null || trackedItemReducer === void 0 ? void 0 : trackedItemReducer.hiddenTrackedItems
                : trackedItemReducer === null || trackedItemReducer === void 0 ? void 0 : trackedItemReducer.userCreatedTrackedItem,
        benchmarkListOptions: (_b = (_a = state.lookups[LookupNames.LKReportTypeBenchmark]) === null || _a === void 0 ? void 0 : _a.filter((x) => parseInt(x.code) !==
            TrackedItemTypebenchmark.TRACKED_ITEM_TYPE_BENCHMARK_CUSTOM //for custom
        )) !== null && _b !== void 0 ? _b : [],
    };
}
const mapDispatchToProps = {
    getTrackedItemTypes,
    getSystemCreatedTrackedItemTypes,
    addTrackedItemType,
    getHiddenTrackedItemTypes,
    editTrackedItemType,
    getLookups,
    getLookup,
    getTrackedItems,
};
export default connect(mapStateTopProps, mapDispatchToProps)(TrackedItemTypeFormContainer);
